<template>
  <div v-if="flag" :class="{ 'has-logo': showLogo }">
    <img src="@/assets/main_images/navbar/sidebar_bg.png" alt="" class="sidebar_bg">
    <!--<logo :big="showLogo" :collapse="isCollapse" />-->
    <ScrollView v-if="style === 'horizontal'" class="horizontalSidebarMenu" wrap-class="scrollbar-wrapper">
      <el-menu :default-active="activeMenu" :background-color="variables.menuBg" @select="selectMenu" :text-color="variables.menuText" :unique-opened="false" :active-text-color="variables.menuActiveText" :collapse-transition="false" :mode="style">
        <sidebar-item v-for="route in menu" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </ScrollView>
    <el-scrollbar v-else wrap-class="scrollbar-wrapper">
      <el-menu :default-active="activeMenu"  @select="selectMenu" :background-color="variables.menuBg" :text-color="variables.menuText" :unique-opened="false" :active-text-color="variables.menuActiveText" :collapse-transition="false" :mode="style">
        <sidebar-item v-for="route in menu" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";
import ScrollView from "@/components/ScrollView"
export default {
  components: { SidebarItem, Logo, ScrollView },
  data() {
    return {
      menu: [],
      flag:true
    }
  },
  computed: {
    ...mapGetters(["sidebar"]),
    ...mapState({
      permission_routes: (state) => {
        return state.user.menus
      },
      style: (state) => state.settings.style,
    }),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  methods:{
    selectMenu(index,indexPath){
      if(index==="/seek/seekMaterialDataSheet"){
        this.$store.commit("user/SET_SEEKMATERIALDATASHEETFLAG", '');
      }
    },
  },
  watch: {
    '$route': function (to) {
      let path = to.path;
      let arr = ['/createComponent/detail', '/createHome/index', '/createComponent/ourinformationCompany', '/createComponent/sendStatusInformation'];
      let arr2 = ['/createComponentUnit/detail', '/createHome2/index']
      let flag = arr.includes(path);
      let flag1 = arr2.includes(path);

      if (flag) {
        this.menu = this.permission_routes.filter(item => {
          return item.meta.type === 'create'
        })
      } else if (flag1) {
        this.menu = this.permission_routes.filter(item => {
          return item.meta.type === 'unit'
        })
      } else {
        this.menu = this.permission_routes.filter(item => {
          return !(item.meta.type === 'create' || item.meta.type === 'unit')
        })
      }
    },
    '$store.state.app.forceMenuHighlight':function(){
      this.flag = false;
      this.$nextTick(()=>{
        this.flag = true;
      })
    }
  },
  mounted() {
    let path = this.$router.currentRoute.path;
    let arr = ['/createComponent/detail', '/createHome/index', '/createComponent/ourinformationCompany', '/createComponent/sendStatusInformation'];
    let arr2 = ['/createComponentUnit/detail', '/createHome2/index']
    let flag = arr.includes(path);
    let flag1 = arr2.includes(path);
    if (flag) {
      this.menu = this.permission_routes.filter(item => {
        return item.meta.type === 'create'
      })
    } else if (flag1) {
      this.menu = this.permission_routes.filter(item => {
        return item.meta.type === 'unit'
      })
    } else {
      this.menu = this.permission_routes.filter(item => {
        return !(item.meta.type === 'create' || item.meta.type === 'unit')
      })
    }
  },
};
</script>
<style lang="scss">
.sidebar_bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}

.el-menu--horizontal {
  display: flex;
}

.horizontalSidebarMenu {
  right: 0px;
  margin-top: 11px;
}
</style>
